/**
 * @file AI 卡片入口
 * @author izzieyspu
 */
import React from 'react';
import { HomeAICard } from '@/ai-assistant';
import Announcement, { AnnouncementEntryProps } from '../announcement';
import { Flex, Text } from '@tencent/odc';
import dayjs from 'dayjs';
import globalStore from '@/stores';

import { HomeRowWrapper } from '../home-item';
import CostBalance from './cost-balance';
import BannerEntry, { BannerGuideProps } from './banner-entry';

type AICardEntryProps = AnnouncementEntryProps & {
  bannerGuide: BannerGuideProps;
};


const AICardEntry: React.FC<AICardEntryProps> = (props) => {
  const { bannerGuide } = props;
  const { operator_name, wechat_avatar, wechat_number } = globalStore.account;

  return (
    <HomeRowWrapper>
      <Flex direction="row" flexAuto className="tw-max-w-[calc(100%-492px)]">
        <HomeAICard />
      </Flex>
      <Flex direction="column" w="480px" bg="white" padding="24" gap="8" radius="8" className="flex-none">
        <Flex className="tw-border-b tw-pb-[12px] tw-min-h-[58px]" gap="8">
          {!!wechat_avatar && <img src={wechat_avatar} className="tw-w-[40px] tw-h-[40px] tw-rounded-full" />}
          <Flex direction="column" gap="0" className="tw-justify-around">
            <Text type="strong" size="large">{`${operator_name}，${dayjs().hour() < 13 ? '上午' : '下午'}好`}</Text>
            {!!wechat_number && <Text type="secondary" size="small">微信号：{wechat_number}</Text>}
          </Flex>
        </Flex>
        <CostBalance />
        <Announcement {...props} />
        <BannerEntry {...bannerGuide} />
      </Flex >
    </HomeRowWrapper>
  );
};

export default AICardEntry;
